import { ReportSummaryItemApi } from "../../api/Reports";
import { formattedDate } from "../../utils";

interface PrintReportHeaderProps {
  reportSummary: ReportSummaryItemApi;
}

const Summary360PrintReportHeader = ({
  reportSummary,
}: PrintReportHeaderProps) => {
  return (
    <div className="hidden print:block w-full text-white relative p-6 bg-gradient-to-r from-gradBlue to-darkBlue rounded-2xl shadow mb-4">
      <div className="text-white flex-grow max-w-lg">
        <h1 className="self-stretch text-5xl font-bold leading-none print:text-3xl mb-2">
          {reportSummary.full_name}
        </h1>
      </div>
      <div className="flex text-sm">
        <div className="flex-1">
          <div className="w-full truncate mb-2 flex gap-2 whitespace-pre-wrap">
            <span className="font-bold">Company:</span>{" "}
            {reportSummary.company_name}
          </div>
          <div className="w-full truncate mb-2">
            <span className="font-bold">Report ID:</span> &nbsp;
            {reportSummary.report_uuid}
          </div>
          <div className="w-full truncate">
            <span className="font-bold">Assignment #/Client Report ID:</span>
            <span className="font-bold">
              &nbsp;{reportSummary.client_report_id || "N/A"}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-2 text-right justify-end w-64 text-sm">
          <div className="w-full truncate">
            <span className="font-bold inline-block mr-1">Completed:</span>
            <span className="">{formattedDate(reportSummary.finish_at)}</span>
          </div>
          <div className="w-full truncate">
            <span className="font-bold">{reportSummary?.blueprint_name}</span>
          </div>
          <div className="w-full truncate">
            <span className="font-bold inline-block mr-1">Requester:</span>
            <span className="w-full truncate">
              {reportSummary.requested_by_name ?? "None"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary360PrintReportHeader;
